import React from 'react'
import { useQuery } from '@apollo/client'
import { GET_TOTAL_NUMBER_OF_TICKET } from '../../../graphql/query'

const SupportTicketCount = () => {
  const {
    data: totalTicket,
    loading: totalTicketsLoading,
    error: totalTicketsError
  } = useQuery(GET_TOTAL_NUMBER_OF_TICKET, {
    context: {
      headers: {
        'access-control-allow-methods': 'Support-Tickets'
      }
    }
  })

  const ticketStatus = [
    {
      id: 't1',
      ticketNumb: totalTicket?.getNumberOfTickets?.numberOfTickets,
      ticket: 'Total Tickets',
      cardStyle: '#ff0066'
    },
    {
      id: 't2',
      ticketNumb: totalTicket?.getNumberOfTickets?.numberOfOpenTickets,
      ticket: 'Open',
      cardStyle: '#ec9d15'
    },
    {
      id: 't3',
      ticketNumb: totalTicket?.getNumberOfTickets?.numberOfResolvedTickets,
      ticket: 'Resolved',
      cardStyle: ' #ff1f94'
    },
    {
      id: 't4',
      ticketNumb: totalTicket?.getNumberOfTickets?.numberOfInProgress,
      ticket: 'In-Progress',
      cardStyle: '#9923be'
    }
  ]

  if (totalTicketsLoading) return <p>Loading...</p>
  if (totalTicketsError) return <p>Error: {totalTicketsError.message}</p>

  return (
    <div className='row g-4'>
      {ticketStatus.map(({ id, ticket, ticketNumb, cardStyle }) => (
        <div
          key={id}
          //   className='col-xl-2 col-lg-4 col-md-4 col-xm-8'
          style={{
            width: '',
            padding: '10px',
            textAlign: 'center',
            borderRadius: '5px',
            flex: '1',
            margin: ' 0 5px'
          }}
        >
          <div
            className='card cursor-pointer'
            style={{
              background: cardStyle,
              color: 'white'
            }}
          >
            <div className='card-body p-4'>
              <div className='d-flex align-items-start justify-content-between'>
                <div className='content-left'>
                  <span>{ticket}</span>
                  <div className='d-flex align-items-end mt-2'>
                    <h4 className='mb-0 me-2 fs-1 text-white'>{ticketNumb}</h4>
                    <small className='text-success mb-0'></small>
                  </div>
                </div>
                <div className='avatar mt-4'>
                  <span className='avatar-initial rounded bg-label danger'>
                    <i
                      className='bi bi-people-fill bg-white p-4 rounded h3'
                      style={{ color: cardStyle }}
                    ></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default SupportTicketCount
